export const checkIsStringRangeValid = (range) => range.from && range.to;
